import { Typography } from '@mui/material'

export const NumberCircle = (props: { children: string }) => {
  return (
    <Typography
      component="span"
      sx={{
        display: 'inline-block',
        width: '26px',
        height: '26px',
        borderRadius: '50%',
        backgroundColor: 'primary.main',
        color: 'white',
        textAlign: 'center',
        lineHeight: '26px',
        fontWeight: 'bold',
        fontSize: '14px',
        flexShrink: 0,
      }}
    >
      {props.children}
    </Typography>
  )
}
